<template>
  <div class="login">
    <div class="login-wrapper">
      <div class="login-logo login-logo_mb">
        <logo />
      </div>

      <form class="login-form" @submit.prevent="singIn">
        <div class="login-form__cat">
          <img src="@/assets/images/orangeCat.svg" alt />
        </div>
        <div class="login-form__greetings">
          <p class="login-form__title">Herzlich willkommen! </p>
          <p class="login-form__subtitle login-form__subtitle_mb">Melden Sie sich bei Ihrem Konto an</p>
        </div>

        <div class="login-form__box login-form__box_mb">
          <label class="main-form__label">E-mail</label>
          <div>
            <input v-model="login.email" type="text" class="main-form__input" />
            <img src="@/assets/images/mail.svg" alt />
          </div>
        </div>
        <div class="login-form__box login-form__box_mb36">
          <label class="main-form__label">{{$t('forms.password')}}</label>
          <div>
            <input v-model="login.password" type="password" class="main-form__input" />
            <img src="@/assets/images/lock.svg" alt />
          </div>
        </div>
        <div class="login-form__box login-form__box_flex">
          <!-- <router-link to="/" class="login-form__forgot-link"
            >Forgot password?</router-link
          >-->
          <button type="submit" class="main-button">{{$t('login.enter')}}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import logo from '@/components/controls/logo'

export default {
    components: {
        logo,
    },
    data() {
        return {
            state: '',
        }
    },
    methods: {
        async singIn() {
            const res = await this.$store.dispatch('singIn', {
                $router: this.$router,
            })
            console.log(res)
        },
        restorePass() {
            this.$store.dispatch('restorePass')
        },
        updateToken() {
            this.$store.dispatch('updateToken')
        },
        changeScreen(name) {
            this.state = name
        },
        closeModal() {
            this.state = 'login'
            this.$store.commit('setStateLogin', { type: 'restore', data: false })
        },
        changeStatusFailed(param) {
            this.$store.commit('setStateLogin', { type: param, data: false })
        },
    // checkIsLogged() {
    //   if (
    //     document.cookie === "" &&
    //     this.$router.history.current.path !== "/admin"
    //   ) {
    //     this.$router.push({ to: "/admin" });
    //   }
    // }
    },
    // created() {
    //   this.checkIsLogged();
    // },
    mounted() {
        setTimeout(() => {
            this.state = this.auth ? '' : 'login'
        }, 1500)
    },
    computed: {
        loading() {
            return this.$store.state.login.loading
        },
        auth() {
            return this.$store.state.login.auth
        },
        login() {
            return this.$store.state.login.data
        },
        disabled() {
            return !(this.$store.state.login.data.password
                && this.$store.state.login.data.email)
        },
        validEmailSingIn() {
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return !(re.test(this.$store.state.login.data.email)
                && this.$store.state.login.data.password)
        },
        validEmailForgot() {
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return !re.test(this.$store.state.login.data.forgotEmail)
        },
        restoreSuccsess() {
            return this.$store.state.login.data.restore
        },
    },
}
</script>

<style lang="scss" scoped>
.login {
  background-color: var(--bg-color-green);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &-wrapper {
    width: 100%;
    max-width: 430px;
  }

  &-logo {
    display: flex;
    justify-content: center;

    &_mb {
      margin-bottom: 128px;
    }
  }

  &-form {
    background: #1e2127;
    border-radius: 2px;
    padding: 45px 48px 48px 48px;
    width: 100%;
    max-width: 430px;
    position: relative;

    &__box {
      margin-bottom: 14px;
      position: relative;

      &_flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      img {
        position: absolute;
        right: 6px;
        bottom: 7px;
      }

      &_mb36 {
        margin-bottom: 36px;
      }
    }

    &__cat {
      position: absolute;
      top: -101px;
      text-align: center;
      width: 100%;
      left: 0;

      img {
        width: 150px;
        height: 130px;
      }
    }

    &__title {
      font-size: 33px;
      text-align: center;
      letter-spacing: -0.8px;
      line-height: 50px;
      color: #ffffff;
      margin: 0 0 8px 0;
      font-family: "lexend_deca";
    }

    &__subtitle {
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      color: #828d99;

      &_mb {
        margin-bottom: 45px;
      }
    }

    &__forgot-link {
      color: var(--bg-color-green);
      font-weight: 600;
      font-size: 13px;
      line-height: 20px;
    }
  }
}
</style>
